import gql from "graphql-tag";

export const shippingZoneActivityLogFragment = gql`
  fragment ShippingZoneActivityLogFragment on ShippingZoneActivityLog {
    id
    createdAt
    newValues
    action
    type
    doer {
      email
    }
  }
`;
